import React, { useState } from "react";
import { connect } from "react-redux";
import { getDataFromAPI } from "../../HandleAPICalls/actions";
import CreateRoster from "./Component.jsx";

const Create_Cst_Roster_Container = (props) => {
  const [loading, setLoading] = useState(false);
  const [openDialog, setOpenDialog] = useState(false);
  const [agentData, setAgentData] = useState(null);

  const create_roster = (payload) => {
    
    setLoading(true);
    props.getDataFromAPI(
      "/partner/api/v1/chat-assignment/update-agent",
      "PUT",
      payload,
      (response) => {
        console.log("response",response)
        setAgentData(response);
        setLoading(false);
        setOpenDialog(true)
        
      },
      () => {
        //setError("Failed to save roster");
        setLoading(false);
      }
    );
  };

  return (
    <>
   
      <CreateRoster
        onPayloadReady={(payload) => {
          create_roster(payload);

        }}
        openDialog={openDialog}
      />

      {agentData && (
        <pre style={{ background: "#eee", padding: "10px", marginTop: "10px" }}>
          {JSON.stringify(agentData, null, 2)}
        </pre>
      )}
    </>
  );
};

export default connect(null, { getDataFromAPI })(Create_Cst_Roster_Container);
